<template>
    <v-card tile flat style="height:100%;">
        <v-card-text>
            <div style="text-align:left; margin:0.5rem;margin-bottom:1.5rem">
                <div class="headline">Device profiles</div>
                <div class="body-1">Device profiles are data structures containing parameters need for device provisioning used to make easier device provisioning process.</div>
            </div>
            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                    <itemlist 
                        :headers="[
                            {text:'Profile name',value:'id'},
                            {text:'Create timestamp',value:'createTime'},
                        ]" 
                        :values="deviceProfiles" 
                        v-on:selected="deviceProfile=$event;"
                        v-on:unselected="deviceProfile=null;"
                    ></itemlist>
                </v-flex>
                <v-flex xs12 sm12 md12 v-if="deviceProfile">
                    <v-card class="elevation-0" >
                        <v-card-title class="title" style="padding-top:1rem">
                            <span>Details of <v-chip>{{ deviceProfile.id }}</v-chip> device profile</span>
                        </v-card-title>
                        <v-card-text style="padding-top:0;padding-bottom:0">
                            <v-layout row wrap style="text-align: left;margin-left:2rem">
                            <v-flex xs12>
                                <v-layout>
                                <v-flex xs3><v-icon small style="margin-right:5px">date_range</v-icon>Create timestamp:</v-flex>
                                <v-flex xs9>{{(typeof deviceProfile.createTime)=='object'?deviceProfile.createTime: new Date(deviceProfile.createTime)}}</v-flex>
                                </v-layout>
                            </v-flex>

                            <v-flex xs12 v-for="(key,index) in Object.keys(deviceProfile.context)" :key="index">
                                <v-layout align-center >
                                <v-flex xs3  >
                                    <div class="text-capitalize">
                                    <v-icon small style="margin-right:5px">view_headline</v-icon>
                                    {{key=='application_eui'?'join_eui':((deviceProfile.id=='ST_LoRa_TTN_Default'&&key=='application_key')?'application & network key':key)}}
                                    </div>
                                </v-flex>
                                <v-flex xs9 >
                                {{deviceProfile.context[key]}}
                                </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 v-if="deviceProfile.converter">
                                <v-layout>
                                <v-flex xs3>
                                    <v-icon small style="margin-right:5px">code</v-icon>Converter:
                                </v-flex>
                                <v-flex xs9 >
                                    {{deviceProfile.converter}}
                                    <!-- <editor v-model="deviceProfile.converter" @init="editorInit" lang="javascript" theme="chrome" width="100%" height="100"></editor> -->
                                </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 v-if="deviceProfile.connectivity">
                                <v-layout>
                                <v-flex xs3>
                                    <v-icon small style="margin-right:5px">view_headline</v-icon>Connectivity:
                                </v-flex>
                                <v-flex xs9 >
                                    {{deviceProfile.connectivity.replace('_', ' ').toUpperCase()}}
                                    <!-- <editor v-model="deviceProfile.converter" @init="editorInit" lang="javascript" theme="chrome" width="100%" height="100"></editor> -->
                                </v-flex>
                                </v-layout>
                            </v-flex>

                            </v-layout>
                        </v-card-text>
                        <v-card-actions style="padding-top:0;">
                            <v-spacer></v-spacer>
                            <v-btn 
                            outline small color="red" 
                            v-on:click="$store.dispatch('deviceProfiles/deleteDeviceProfile',deviceProfile);deviceProfile = null">
                            <v-icon small>close</v-icon> Delete
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card-text>


        <v-card-actions>
            <v-spacer></v-spacer>
            <v-alert
                :value="refreshDeviceProfilesHint"
                type="warning"
                class="hint"
                transition="scale-transition"
            >
                Please, refresh profiles list
            </v-alert>
            <v-btn 
                dark icon class="blue"
                v-on:click="$store.dispatch('deviceProfiles/fetchDeviceProfiles');refreshDeviceProfilesHint=false"
            >
                <v-icon>sync</v-icon>
            </v-btn>
            <v-btn dark icon class="blue" v-on:click="openDeviceProfileRegistrationProcess=!openDeviceProfileRegistrationProcess">
                <v-icon>add</v-icon>
            </v-btn>
            <register-deviceprofile
                v-if="openDeviceProfileRegistrationProcess==true"
                v-on:abort="openDeviceProfileRegistrationProcess=false"
                v-on:completed="openDeviceProfileRegistrationProcess=false;refreshDeviceProfilesHint=true"
                :values="{
                    converter: dataConverters.map(dc=>{return {text:dc.label,ref:dc.id}}),
                    dsh_api_key: apiKeys.map(ak=>{ return {text:ak.label, ref:ak.value}}),
                }"
            ></register-deviceprofile>
        </v-card-actions>

    </v-card>   


</template>
<script>
import { mapState } from 'vuex';

export default {

    components:{
        itemlist: require('../../ItemList').default
    },

    props:{
        theme:String
    },
    
    data(){
        return {
            refreshDeviceProfilesHint:false,
            deviceProfile: null,
            openDeviceProfileRegistrationProcess:false,
        }
    },

    computed:{
        ...mapState(
            {
                lastOperationMessage:'lastOperationMessage',
                lastOperationSuccess:'lastOperationSuccess',
                operationInProcess:'operationInProcess',
                operationInProcessMessage: 'operationInProcessMessage',
                deviceProfiles: state => state.deviceProfiles.deviceProfiles,
                dataConverters: state => state.deviceProfiles.dataConverters,
                apiKeys: state => state.apiKeys.apiKeys,
                firmwares : state => state.devices.firmwares,
                appMetadata: state => state.metadata.models.views
            }
        ),
    },

}
</script>
